import React, { useState, useRef, useEffect } from 'react';
import { Form, Dropdown } from 'react-bootstrap';

const MultiSelect = ({
    options = [],
    selectedValues = [],
    onChange,
    placeholder = "Select options...",
    disabled = false,
    loading = false,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const handleToggle = (nextOpenState) => {
        if (!disabled && !loading) {
            setIsOpen(nextOpenState);
        }
    };

    const handleOptionClick = (value, e) => {
        e.stopPropagation();
        const isSelected = selectedValues.includes(value);
        let newSelectedValues;

        if (isSelected) {
            newSelectedValues = selectedValues.filter((v) => v !== value);
        } else {
            newSelectedValues = [...selectedValues, value];
        }

        onChange(newSelectedValues);
    };

    const getDisplayText = () => {
        if (loading) return "Loading...";
        if (selectedValues.length === 0) return placeholder;
        if (selectedValues.length === 1) {
            const option = options.find((opt) => opt.value === selectedValues[0]);
            return option?.label || selectedValues[0];
        }
        return `${selectedValues.length} selected`;
    };

    return (
        <Dropdown
            ref={dropdownRef}
            show={isOpen}
            onToggle={handleToggle}
            className="d-inline-block"
        >
            <Dropdown.Toggle
                variant="outline-secondary"
                size="sm"
                disabled={disabled || loading}
                style={{
                    minWidth: "200px",
                    textAlign: "left",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                {getDisplayText()}
            </Dropdown.Toggle>
            <Dropdown.Menu
                style={{
                    maxHeight: "300px",
                    overflowY: "auto",
                }}
            >
                {options.length === 0 && !loading && (
                    <Dropdown.Item disabled>No options available</Dropdown.Item>
                )}
                {loading && (
                    <Dropdown.Item disabled>Loading...</Dropdown.Item>
                )}
                {options.map((option) => {
                    const isSelected = selectedValues.includes(option.value);
                    return (
                        <Dropdown.Item
                            key={option.value}
                            onClick={(e) => handleOptionClick(option.value, e)}
                            active={isSelected}
                        >
                            <div className="d-flex align-items-center">
                                <Form.Check
                                    type="checkbox"
                                    checked={isSelected}
                                    onChange={() => {}}
                                    className="me-2"
                                    readOnly
                                />
                                <span>{option.label}</span>
                            </div>
                        </Dropdown.Item>
                    );
                })}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default MultiSelect;


